import { HttpClient } from '@angular/common/http'
import { Component, Injectable, OnInit } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { NotificationPreference, UserNotificationPreferenceService } from '@spartacus/core'
import { Observable, throwError } from 'rxjs'
import { AppConfigurationService } from '../../services/app-configuration.service'

@Injectable()
@Component({
    selector: 'app-custom-notification-preference',
    templateUrl: './custom-notification-preference.component.html',
    styleUrls: ['./custom-notification-preference.component.scss'],
    standalone: false
})
export class CustomNotificationPreferenceComponent implements OnInit {
  preferences$: Observable<NotificationPreference[]>
  isLoading$: Observable<boolean>
  showNotification: boolean = false

  // protected preferences: NotificationPreference[] = [];
  // public preferences: NotificationPreference[];
  preferencesData: any
  public showSpinnerOnDataLoad = false
  preferenceDataLength: number
  message: string
  // headers: Headers;
  preferenceObjData: any
  // options: RequestOptions;

  constructor(
    private notificationPreferenceService: UserNotificationPreferenceService,
    private snackBar: MatSnackBar,
    private appConfigurationService: AppConfigurationService,
    public http: HttpClient
  ) {
    // this.headers = new Headers({ 'Content-Type': 'application/json',
    //                                   'Accept': 'q=0.8;application/json;q=0.9' });
    //      this.options = new RequestOptions({ headers: this.headers });
  }

  ngOnInit(): void {
    this.notificationPreferenceService.resetNotificationPreferences()
    // this.preferences$ = this.notificationPreferenceService.getPreferences();
    // setTimeout(() => {
    // this.preferences$ = this.notificationPreferenceService
    //   .getPreferences()
    //   .pipe(tap((preferences) => (this.preferences = preferences)));
    // }, 500);

    // this.preferencesData = this.getNotificationPreferences();
    this.notificationPreferenceService.loadPreferences()
    setTimeout(() => {
      this.getNotificationPreferences()
      this.showNotification = true
    }, 500)
    // this.isLoading$ = combineLatest([
    //   this.notificationPreferenceService.getPreferencesLoading(),
    //   this.notificationPreferenceService.getUpdatePreferencesResultLoading(),
    // ]).pipe(
    //   map(([prefsLoading, updateLoading]) => prefsLoading || updateLoading)
    // );
    // setTimeout(() => {
    //    this.getNoofocationPreferences();
    // }, 200);
  }

  async getNotificationPreferences() {
    this.showSpinnerOnDataLoad = true
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const addressUrl = `${baseSiteUrl}/users/current/notificationpreferences?lang=en&curr=AUD`
    //  return this.http.get(addressUrl).subscribe((responseData: any) => {
    return this.http.get(addressUrl).subscribe(
      (responseData: any) => {
        this.showSpinnerOnDataLoad = false
        this.showNotification = true
        this.preferencesData = responseData.preferences
        this.preferenceObjData = responseData
        this.preferenceDataLength = responseData.preferences.length
      },
      (error) => {
        this.showSpinnerOnDataLoad = false
        this.showNotification = false
        // console.error('Error fetching data: ', error);
        return throwError(error)
      }
    )
  }

  public updatePreferencesSwitch(preferenceObjData) {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const updatePreferencesUrl = `${baseSiteUrl}/users/current/notificationpreferences?lang=en&curr=AUD`
    return (
      this.http.patch(updatePreferencesUrl, this.preferenceObjData).subscribe(),
      (error) => {
        this.showSpinnerOnDataLoad = false
        return throwError(error)
      }
    )
  }

  // updatePreference(preference: NotificationPreference): void {
  public updatePreference(preference: NotificationPreference): void {
    const updatedPreferences = []

    this.preferencesData.forEach((p) => {
      if (p.channel === preference.channel) {
        updatedPreferences.push({
          ...p,
          enabled: !p.enabled
        })
      } else {
        updatedPreferences.push(p)
      }
    })

    const emailPreference = this.preferenceObjData.preferences.find((pref) => pref.channel === 'EMAIL')

    if (emailPreference) {
      emailPreference.enabled = !emailPreference.enabled
    }
    this.updatePreferencesSwitch(this.preferenceObjData)
    this.openSnackBar(updatedPreferences[0].enabled)
  }

  openSnackBar(preferenceEnabled: boolean): void {
    // let message: string;
    if (preferenceEnabled) {
      this.message = 'Email preference is enabled'
    } else {
      this.message = 'Email preference is disabled'
    }
    this.snackBar.open(this.message, null, {
      duration: 2500,
      panelClass: ['snackbar']
    })
  }
}
